import context from './context'

export default {
  data () {
    return {
      isExporting: false,

      fileTypes: [{
        key: 'xlsx',
        title: this.$i18n.t('reporting.fileTypes.types.xlsx.title'),
        icon: ['fas', 'file-excel']
      }, {
        key: 'csv',
        title: this.$i18n.t('reporting.fileTypes.types.csv.title'),
        icon: ['fas', 'file-csv']
      }]
    }
  },

  mixins: [context],

  methods: {
    /**
     * On export click
     *
     * @param {string} fileType xlsx or csv
     */
    onExportClick (fileType) {
      this.isExporting = true

      this.getExportDelegate(Object.assign({ filetype: fileType }, this.getExportParameters())).then(() => {
        this.$store.dispatch('showMessage', { title: this.$i18n.t('sentence.reportQueued'), autoHideDelay: 7500, route: { name: 'reportingOverview' }, options: { variant: 'info' } })
      }).finally(() => {
        this.isExporting = false
      })
    },

    /**
     * Get export function
     *
     * @param {Array} parameters
     */
    getExportDelegate (parameters) {
      throw new Error('Not implemented')
    },

    /**
     * Get additional export parameters
     */
    getExportParameters () {
      return {}
    }
  }
}
